import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import { objectLength } from "components/ProjectNonSpecificComponents/Functions/objectLength"
import {
	ADMIN_PANEL_FORM_IDS,
	PTKM_FORM_IDS,
	PTKM_PANEL_FORM_NAMES,
} from "components/ProjectSpecificComponents/Constants/ADMIN_PANEL_CONSTANTS"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import scrollToId from "components/ProjectSpecificComponents/Functions/scrollToId"
import { observer } from "mobx-react"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import SideNavItem from "../atoms/SideNavItem"

interface Props {
	textHidden?: boolean
}

const PTKMSideNav = observer(({ textHidden = false }: Props) => {
	const store = useStore()
	const { t } = useTranslation()

	return (
		<>
			<HyperDiv
				width="100%"
				direction="column"
				padding="0 .75rem"
				alignedRight={!textHidden}
				centeredY={textHidden}
			>
				<SideNavItem
					iconKey="item-type"
					textHidden={textHidden}
					children={t("forms.header.deadlines")}
					onClick={() => scrollToId(PTKM_FORM_IDS.deadlines)}
					sectionKey="deadlines"
				/>
				<SideNavItem
					iconKey="layers"
					textHidden={textHidden}
					children={t("forms.header.status")}
					onClick={() => scrollToId(PTKM_FORM_IDS.statuses)}
					sectionKey="statuses"
				/>
				<SideNavItem
					iconKey="blank-page"
					textHidden={textHidden}
					children={t("forms.header.rlakr")}
					onClick={() => scrollToId(PTKM_FORM_IDS.rlakr)}
					sectionKey="rlakr"
				/>
			</HyperDiv>
		</>
	)
})

export default PTKMSideNav
